import React from 'react';

import { ReactComponent as HeaderIcon } from 'assets/images/burger-menu-icon.svg';
import { ReactComponent as LayoutIcon } from 'assets/images/layout-justify-between.svg';
import { ReactComponent as IconBlockIcon } from 'assets/images/emoji-panel-toggle-icon.svg';

// Menu icons for the layout, icon and header blocks; null for every other type.
export function renderBlockIcon(type) {

  if (type === 'site-nav') {
    return <HeaderIcon className="action-icon" width="24" height="24" />;
  }

  if (type === 'layout') {
    return <LayoutIcon className="button-block-action-icon" width="24" height="24" />;
  }

  if (type === 'icon') {
    return <IconBlockIcon className="action-icon" width="24" height="24" />;
  }

  return null;

}
